import React, { useState } from 'react';

const CalculatorPump = () => {
    const [investitionssumme, setInvestitionssumme] = useState('');
    const [wohneinheiten, setWohneinheiten] = useState(1);
    const [kaeltemittel, setKaeltemittel] = useState('ja');
    const [alteHeizung, setAlteHeizung] = useState('ja');
    const [einkommensbonus, setEinkommensbonus] = useState('ja');
    const [foerderbetrag, setFoerderbetrag] = useState(null);
    const [error, setError] = useState('');

    const handleCalculate = () => {
        const investVal = parseFloat(investitionssumme);
        if (isNaN(investVal) || investVal <= 0) {
            setError('Bitte gültige Investitionssumme eingeben');
            setFoerderbetrag(null);
            return;
        }

        setError('');
        const wohneinheitenVal = parseInt(wohneinheiten);
        const kaeltemittelVal = kaeltemittel === 'ja';
        const alteHeizungVal = alteHeizung === 'ja';
        const einkommensbonusVal = einkommensbonus === 'ja';

        let foerderfaehigeKosten = 0;
        if (wohneinheitenVal > 0) {
            foerderfaehigeKosten += 30000;
            if (wohneinheitenVal > 1) {
                const weitereWohneinheiten = Math.min(wohneinheitenVal - 1, 7);
                foerderfaehigeKosten += weitereWohneinheiten * 15000;
                if (wohneinheitenVal > 8) {
                    foerderfaehigeKosten += (wohneinheitenVal - 8) * 10000;
                }
            }
        }

        foerderfaehigeKosten = Math.min(investVal, foerderfaehigeKosten);

        let foerderProzent = 30;
        if (kaeltemittelVal) foerderProzent += 5;
        if (alteHeizungVal) foerderProzent += 20;
        if (einkommensbonusVal) foerderProzent += 30;
        foerderProzent = Math.min(foerderProzent, 70);

        setFoerderbetrag(foerderfaehigeKosten * (foerderProzent / 100));
    };

    return (
        <div className="w-full flex justify-center py-6 px-4 sm:px-8 md:px-16">
            <div className="w-full lg:w-3/4 bg-white px-4 sm:px-6 lg:px-8 py-8 sm:py-10 rounded-2xl border bg-secondary-light shadow-lg">
                <h3 className="text-2xl sm:text-3xl lg:text-4xl text-primary font-bold mb-4 text-center">
                    Förderrechner für Wärmepumpen
                </h3>

                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Bruttoangebotssumme inkl. MwSt. (€):</label>
                        <input
                            type="number"
                            value={investitionssumme}
                            onChange={(e) => setInvestitionssumme(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                            placeholder="50.000"
                        />
                        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">Wie viele Wohneinheiten hat das Gebäude?</label>
                        <select
                            value={wohneinheiten}
                            onChange={(e) => setWohneinheiten(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            {[...Array(8).keys()].map(i =>
                                <option key={i} value={i+1}>{i+1}</option>
                            )}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">
                            Wärmepumpen-Bonus, wenn Wärmequelle Wasser, Erdreich, Abwasser oder natürliche Kältemittel
                        </label>
                        <select
                            value={kaeltemittel}
                            onChange={(e) => setKaeltemittel(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            <option value="ja">Ja</option>
                            <option value="nein">Nein</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">
                            Geschwindigkeitsbonus, für selbstnutzende Wohneigentümer bei Austausch von Öl-, Gas- (> 20 Jahre), Kohle-, Nachtspeicher-Heizung bis spätestens 2028
                        </label>
                        <select
                            value={alteHeizung}
                            onChange={(e) => setAlteHeizung(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            <option value="ja">Ja</option>
                            <option value="nein">Nein</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-dark mb-2">
                            Einkommensbonus für selbstnutzende Wohneigentümer mit einem zu versteuernden Einkommen kleiner 40.001 EUR
                        </label>
                        <select
                            value={einkommensbonus}
                            onChange={(e) => setEinkommensbonus(e.target.value)}
                            className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-primary focus:border-primary"
                        >
                            <option value="ja">Ja</option>
                            <option value="nein">Nein</option>
                        </select>
                    </div>

                    <button
                        onClick={handleCalculate}
                        className="w-full p-3 bg-primary text-white rounded-xl mt-6 hover:bg-primary-dark focus:outline-none"
                    >
                        Förderung berechnen
                    </button>

                    {foerderbetrag !== null && !error && (
                        <div className="w-full mt-6 p-6 bg-primary/10 rounded-xl border border-primary/20 text-center">
                            <div className="text-lg font-semibold text-secondary-dark">Ihr Förderbetrag beträgt:</div>
                            <div className="text-2xl font-bold text-primary">{foerderbetrag.toFixed(2)} €</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CalculatorPump;
